import template from './translates.html';
import controller from './translates.controller';
import './translates.styl';

const templatesComponent = {
  template,
  controller,
  controllerAs: 'translates'
};

export default templatesComponent;


/** WEBPACK FOOTER **
 ** ./frontend/components/translates/translates.component.js
 **/